export const MENUITEMS = [
  {
    Items: [
      {
        title: "dashboard",
        icon: "home",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/dashboard`,
      },
    ],
  },
  {
    menutitle: "operation",
    menucontent: "Reservations,Transactions,Permits",
    Items: [
      {
        title: "reservations",
        icon: "calendar",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/reservations`,
      },
    
      {
        title: "transactions",
        icon: "transaction",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/transactions`,
        roles: ["superadmin", "finance"]
      },
    ]
  },
  {
    menutitle: "deals",
    menucontent: "Packages,Promotions",
    Items: [
      {
        title: "promotions",
        icon: "star",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/promotions`,
      },
    
      {
        title: "packages",
        icon: "board",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/packages`,
      },
    
    ]
  },
  {
    menutitle: "insights",
    menucontent: "Reports,Acitivity Logs",
    Items: [
      {
        title: "reports",
        icon: "report",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/reports`,
        roles: ["superadmin", "operation", "finance"]
      },
      {
        title: "activity logs",
        icon: "sample-page",
        type: "sub",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/activity-logs`,
        roles: ["superadmin", "operation", "finance"]
      },
    ]
  },
  {
    menutitle: "configurations",
    menucontent: "Users,Lots,Settings",
    Items: [
      {
        title: "lots",
        icon: "campsite",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/lots`,
      },
      {
        title: "inventory",
        icon: "builders",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/inventory`,
      },
      {
        title: "calendar",
        icon: "calendar",
        type: "sub",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/calendar`,
      },
      {
        title: "pages",
        icon: "blog",
        type: "sub",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/pages`,
      },
      {
        title: "users",
        icon: "user",
        type: "sub",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/users`,
      },
    ]
  }
];